var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0L6.66877 3.33123L10 5L6.66877 6.66877L5 10L3.33123 6.66877L0 5L3.33123 3.33123L5 0Z",
    fill: "#12B16E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStar);
export default __webpack_public_path__ + "static/media/green_star.d86bc2d282bc6c1658819b2a8df29ce2.svg";
export { ForwardRef as ReactComponent };